export default __webpack_public_path__ + "static/img/internal5.20aa8d5.jpg";